import angular from 'angular';
import '../../shared.module';
import template from './pix-payment.component.html';
import './pix-payment.component.scss';
import { renderQrDataUrl } from '../../helpers/qr-image.helper';
import { CHARGE_STATUS_LABELS } from '../order-status.constant';

const COPIED_FEEDBACK_MS = 2500;

class PixPaymentController {
  constructor($window, $timeout, $scope) {
    this.$window = $window;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.statusLabels = CHARGE_STATUS_LABELS;
    this.qrImage = null;
    this.qrFailed = false;
    this.copyState = null;
  }

  $onChanges(changes) {
    if (changes.code) this.renderQr();
  }

  $onDestroy() {
    if (this.copyTimer) this.$timeout.cancel(this.copyTimer);
  }

  renderQr() {
    const code = this.code;
    this.qrImage = null;
    this.qrFailed = false;
    if (!code) return null;
    return renderQrDataUrl(code).then(
      (image) => this.$scope.$applyAsync(() => {
        if (this.code === code) this.qrImage = image;
      }),
      () => this.$scope.$applyAsync(() => {
        this.qrFailed = true;
      })
    );
  }

  copy() {
    const clipboard = this.$window.navigator && this.$window.navigator.clipboard;
    if (!clipboard || !this.code) {
      this.copyState = 'failed';
      return null;
    }
    return clipboard.writeText(this.code).then(
      () => this.showCopyState('copied'),
      () => this.showCopyState('failed')
    );
  }

  showCopyState(state) {
    this.copyState = state;
    if (this.copyTimer) this.$timeout.cancel(this.copyTimer);
    this.copyTimer = this.$timeout(() => {
      this.copyState = null;
    }, COPIED_FEEDBACK_MS);
  }
}

PixPaymentController.$inject = ['$window', '$timeout', '$scope'];

angular.module('app.shared').component('cpPixPayment', {
  bindings: {
    code: '<',
    amount: '<',
    orderNumber: '@',
    status: '@',
    expiresAt: '<'
  },
  controller: PixPaymentController,
  controllerAs: 'vm',
  template
});
